/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 2194421430@qq.com
 * @Date: 2021-04-19 12:05:04
 * @LastEditors: sj
 * @LastEditTime: 2022-06-20 16:45:40
 */
import {
  Button,
  Col,
  Form,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Table,
  Tabs,
} from "antd"
import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { NavBar } from "../../../compnents/nav/NavBar"
import { RootDispatch } from "../../../app/store"
import axios from "axios"
import { useLocation } from "react-router-dom"
import styles from "../filing.module.css"
import { PreviewImgOrPdf } from "../Preview"
import { getSJWHTokenAsync } from "../../dataMaintenance/organization/data"
import { unwrapResult } from "@reduxjs/toolkit"
import { AXIOS_IP, download, exportPdf } from "../fileUploadService"

export const FreeMediaDetail = () => {
  const { TabPane } = Tabs

  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const location: any = useLocation()

  const [detail, setDetail] = useState<any>({})

  const [previewFile, setPreviewFile] = useState<any>() //预览

  const [token, setToken] = useState("")

  const [exportPdfLoading, setExportPdfLoading] = useState(false)

  const getData = () => {
    dispatch(getSJWHTokenAsync())
      .then(unwrapResult)
      .then((token: any) => {
        setToken(token)
        axios({
          url:
            location.state?.state == 1
              ? `${AXIOS_IP}/filingFreeClinic/detail`
              : `${AXIOS_IP}/filingReviewFreeClinic/detail`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": token,
          },
          withCredentials: false,
          method: "POST",
          data: { id: location.state?.id },
        }).then((res) => {
          const data = res.data.data
          const filterData = {
            ...data,
            situationDescriptionFile: data?.situationDescriptionFile || [],
            responsibilityCommitmentFile:
              data?.responsibilityCommitmentFile || [],
            qualificationCopyFile: data?.qualificationCopyFile || [],
            institutionalCertificationFile:
              data?.institutionalCertificationFile || [],
            urbanManagementApprovalFile:
              data?.urbanManagementApprovalFile || [],
          }
          setDetail(filterData)
        })
      })
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <>
      <Col>
        <NavBar
          where={["备案管理", "义诊备案详情"]}
          backtrace={{
            name: "备案管理",
            path: "/filingManagement",
            state: { fillingType: location.state?.type },
          }}
          buttons={
            location.state?.state == 1 ? (
              [
                <Button
                  key="0"
                  type="primary"
                  loading={exportPdfLoading}
                  onClick={() =>
                    exportPdf({
                      data: { filingFreeClinicId: location.state?.id },
                      token,
                      path: "/filingFreeClinic/generatePdf",
                      fileName: "义诊备案详情.pdf",
                      callback: setExportPdfLoading,
                    })
                  }
                >
                  导出
                </Button>,
              ]
            ) : (
              <></>
            )
          }
        />
      </Col>
      <div
        style={{
          height: "calc(100% - 20px)",
          overflow: "auto",
          margin: "10px 0px",
          padding: "20px",
          background: "#fff",
          borderRadius: "10px",
          position: "relative",
        }}
      >
        <Form
          form={form}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 20 }}
        >
          <Row
            style={{
              fontWeight: "bold",
              fontSize: "17px",
              paddingLeft: "15px",
              paddingBottom: "30px",
            }}
          >
            义诊备案详情
          </Row>
          <Form.Item label="义诊时间" name="startTime" rules={[{ required: true }]}>
            {detail?.startTime}~{detail?.endTime}
          </Form.Item>
          <Form.Item label="义诊地点" name="location" rules={[{ required: true }]}>{detail?.location}</Form.Item>
          <Form.Item label="义诊内容" name="content" rules={[{ required: true }]}>{detail?.content}</Form.Item>
          <Form.Item label="义诊情况说明" name="situationDescription" rules={[{ required: true }]}>
            {detail?.situationDescriptionFile?.map((v: any) => {
              return (
                <span key={v.filePath}>
                  {v.fileName}{" "}
                  <a
                    style={{ color: "#0076FF", paddingLeft: "20px" }}
                    onClick={() => setPreviewFile(v)}
                  >
                    查看
                  </a>
                </span>
              )
            })}
          </Form.Item>
          <Form.Item label="责任承诺书" name="responsibilityCommitment" rules={[{ required: true }]}>
            {detail?.responsibilityCommitmentFile?.map((v: any) => {
              return (
                <span key={v.filePath}>
                  {v.fileName}{" "}
                  <a
                    style={{ color: "#0076FF", paddingLeft: "20px" }}
                    onClick={() => setPreviewFile(v)}
                  >
                    查看
                  </a>
                </span>
              )
            })}
          </Form.Item>
          <Form.Item label="资质复印件" name="qualificationCopy" rules={[{ required: true }]}>
            {detail?.qualificationCopyFile?.map((v: any) => {
              return (
                <span key={v.filePath}>
                  {v.fileName}{" "}
                  <a
                    style={{ color: "#0076FF", paddingLeft: "20px" }}
                    onClick={() => setPreviewFile(v)}
                  >
                    查看
                  </a>
                </span>
              )
            })}
          </Form.Item>
          <Form.Item label="同意参加义诊证明">
            {detail?.institutionalCertificationFile?.map((v: any) => {
              return (
                <span key={v.filePath}>
                  {v.fileName}{" "}
                  <a
                    style={{ color: "#0076FF", paddingLeft: "20px" }}
                    onClick={() => setPreviewFile(v)}
                  >
                    查看
                  </a>
                </span>
              )
            })}
          </Form.Item>
          <Form.Item label="城管部门的同意书">
            {detail?.urbanManagementApprovalFile?.map((v: any) => {
              return (
                <span key={v.filePath}>
                  {v.fileName}{" "}
                  <a
                    style={{ color: "#0076FF", paddingLeft: "20px" }}
                    onClick={() => setPreviewFile(v)}
                  >
                    查看
                  </a>
                </span>
              )
            })}
          </Form.Item>
        </Form>
      </div>

      <PreviewImgOrPdf
        token={token}
        AXIOS_IP={AXIOS_IP}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
      />
    </>
  )
}
